module.exports = __webpack_public_path__ + "img/mcontact1.c93e9099.png";